import React, { useEffect, useState } from "react";
import { Typography, MenuItem, Select, IconButton, CircularProgress } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import { Remove } from "@material-ui/icons";

import { getServerUri } from "../modules/uriUtility";
import _ from "lodash";
import { makeStyles } from "@material-ui/core/styles";
import DialogImageDelete from "./dialogImageDelete";
import ReactGA4 from "react-ga4";
import Tooltip from "@mui/material/Tooltip";
ReactGA4.initialize("G-TB46JQ70PR", {
  debug: false,
  gaOptions: {
    userId: localStorage.getItem("user.id"),
  },
});
const useStyles = makeStyles({
  iconButton: {
    padding: 0,
  },

  container: {
    display: "flex",
    alignItems: "center",
    margin: "60px",
    flexDirection: "column",
    maxHeight: "800px",
    "@media (min-width: 780px)": {
      flexDirection: "row",
    },
  },
});

/**
 *
 * @param props
 * @param props.images
 * @param props.selectedImage
 * @param props.classes
 * @param props.setValue
 * @param props.path
 * @param props.destination
 * @param props.bucket
 * @param props.componentType
 * @param props.insertMediaPathValue
 * @param props.componentID
 * @param props.selectedBase
 * @param props.createSnackbar
 * @param props.deleteImageFromMedia
 * @param props.fetchVersions
 * @param props.fetchImages
 * @param props.setIsDialogConfirmRefreshOpen
 * @param props.setIsDialogCircularProgressOpen
 * @returns {JSX.Element|null}
 */
export default function selectorImage(props) {
  const [images, setImages] = useState(imagesToView(_.get(props, "images", [])));
  const [key, setKey] = useState(Date.now());

  const [selectedImageID, setSelectedImageID] = useState(
    isSelectionValid(_.get(props, "selectedImage._id"))
      ? _.get(props, "selectedImage._id")
      : String(_.get(images, "[0]._id", ""))
  );
  const [isDeleteImageDialogOpen, setIsDeleteImageDialogOpen] = useState(false);
  const [imageToDelete, setImageToDelete] = useState(null);
  const [isUploading, setIsUploading] = useState(false);

  const defaultImageID = String(_.get(images, "[0]._id", ""));

  const classes = useStyles();
  // const canvasRef = useRef(null);
  useEffect(() => {
    if (isSelectionValid(_.get(props, "selectedImage._id", ""))) {
      setSelectedImageID(_.get(props, "selectedImage._id", ""));
    } else if (isSelectionValid(defaultImageID)) {
      selectImage(defaultImageID);
    }
  }, [_.get(props, "selectedVersion")]);

  function imagesToView(images) {
    return images.filter((image) => {
      return _.get(image, "bucket") === _.get(props, "bucket");
    });
  }
  function gettingMargin(numberMargin) {
    if (props.tooltip != undefined) {
      if (numberMargin) {
        return numberMargin.toString() + "px";
      }
    } else return (0).toString() + "px";
  }

  let fileSelectors = [];
  let [uploadStatus, setUploadStatus] = useState("ready");

  useEffect(() => {
    setImages(imagesToView(_.get(props, "images", [])));
  }, [_.get(props, "images", []), _.size(props.images)]);

  useEffect(() => {
    if (_.size(images) > 0 && !isSelectionValid(selectedImageID)) {
      selectImage(String(images[0]._id));
    }
  }, [images]);
  function isSelectionValid(id, newImages) {
    let images2;
    if (_.isNil(newImages)) {
      images2 = images;
    } else {
      images2 = newImages;
    }
    const foundImages = images2.filter((image) => {
      return String(image._id) === String(id);
    });
    return foundImages.length > 0 || id === "";
  }

  const inputID = `${_.get(props, "componentID")}-${_.get(props, "path")}`;

  function selectImage(id, newImages) {
    if (!isSelectionValid(id, newImages)) return;
    setSelectedImageID(id);
    let images2;
    if (_.isNil(newImages)) {
      images2 = images;
    } else {
      images2 = newImages;
    }
    const selectedImageRecord = images2.filter((imageRecord) => {
      return String(imageRecord._id) === String(id);
    })[0];
    const newSelectedImageRecord = _.clone(selectedImageRecord);
    _.set(newSelectedImageRecord, "destination", _.get(props, "destination"));
    _.set(newSelectedImageRecord, "path", _.get(props, "path"));
    props.setValue({
      value: [newSelectedImageRecord],
    });
  }
  //it draws a checkerboard pattern on the background.
  function setInputFileListEmpty(inputId) {
    let list = new DataTransfer();
    document.getElementById(inputId).files = list.files;
  }

  function uploadFile(file, fileName) {
    const formData = new FormData();
    formData.append("files", file);
    formData.append("componentType", _.get(props, "componentType"));
    formData.append("path", _.get(props, "path"));
    formData.append("bucket", _.get(props, "bucket"));
    formData.append("accessToken", localStorage.getItem("session.accessToken"));
    formData.append("uploadedFileName", fileName);
    formData.append("compress", String(localStorage.getItem("settings.autoCompress") !== "false"));

    setIsUploading(true);

    fetch(getServerUri("media/uploadImage"), {
      method: "POST",
      body: formData,
    })
      .then((response) => {
        setIsUploading(false);
        if (response.status !== 200) {
          if (response.status === 401) {
            props.createSnackbar("You are not authorized to insert, contact your administrator.", "warning");
          } else {
            props.createSnackbar("Image upload failed. (" + response.status + ")", "error", false);
          }
          response.text().then(console.error).catch(console.error);
        } else {
          response.json().then((objectResponse) => {
            console.info("Upload successful");
            const newImages = _.cloneDeep(images);
            const newRecords = _.get(objectResponse, "records", []);
            newImages.push(...newRecords);
            setImages(newImages);

            props.insertMediaPathValue({ path: "images", value: newRecords });

            const newImageID = String(newRecords[0]._id);
            setSelectedImageID(newImageID);
            selectImage(newImageID, newImages);
            setInputFileListEmpty(inputID);

            const compression = _.get(objectResponse, "compression");
            console.log("[SmartCompress] image response:", compression);
            if (compression && parseFloat(compression.savedPercent) > 0) {
              props.createSnackbar(<span>Image optimized by <strong>{compression.savedPercent}%</strong> with Smart Auto-Optimize.</span>, "success", false);
            } else if (!compression) {
              props.createSnackbar(
                "Smart Auto-Optimize is disabled. Images are uploaded without optimization.",
                "warning",
                false,
                () => window.dispatchEvent(new CustomEvent("openToolSettings")),
                "Enable in Tool Settings"
              );
            }

            ReactGA4.event({
              category: "Preview",
              action: "Image upload",
              label:
                "filename: " + fileName +
                " path " + _.get(props, "path") +
                " ,base: " + props.selectedBase.title +
                " ,originalVersion: " + props.selectedVersion.title,
              dimension1: localStorage.getItem("user.id"),
            });
          });
        }
      })
      .catch((err) => {
        console.error(err);
        setIsUploading(false);
        props.createSnackbar("Could not reach server. Please check your connection.", "error", false);
      });
  }

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const newFileName = file.name.substring(0, file.name.lastIndexOf(".")) || file.name;
    setKey(Date.now());

    const fileSizeInMB = file.size / (1024 * 1024);
    ReactGA4.event({
      category: "Preview",
      action: "Image upload page is open",
      label:
        "filename: " +
        file.name +
        "fileSize in mb: " +
        fileSizeInMB +
        " ,base: " +
        props.selectedBase.title +
        " ,originalVersion: " +
        props.selectedVersion.title,
      dimension1: localStorage.getItem("user.id"),
    });
    if (fileSizeInMB > 3) {
      props.createSnackbar("File size should be 3MB ", "warning", false);
      return;
    }

    const img = new Image();
    img.onload = () => {
      if (img.height > 4096 || img.width > 4096) {
        props.createSnackbar("Height and width must not exceed 4096px", "error");
        return;
      }
      uploadFile(file, newFileName);
    };
    img.src = URL.createObjectURL(file);
  };
  return (
    <div id={`${props.id}.Div`}>
      {props.isVisible && (
        <>
          {_.get(props, "label") && (
            <Typography style={{ marginTop: gettingMargin(props.tooltipLength) }} id="discrete-slider" gutterBottom>
              {_.get(props, "label")}
            </Typography>
          )}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-start",
            }}
          >
            <input
              id={inputID}
              type={"file"}
              key={key}
              hidden={"hidden"}
              multiple={true}
              accept=".jpeg, .png, .jpg, .gif, .webp"
              onChange={handleFileUpload}
            />

            <Select
              onChange={(event) => {
                if (props.userPermissions["editContent"] === false) {
                  props.createSnackbar(
                    "You do not have permission to update, contact your administrator.",
                    "warning",
                    false
                  );
                  return;
                }
                if (isSelectionValid(String(event.target.value))) {
                  selectImage(String(event.target.value));
                }
              }}
              className={props.classes.imageSelector}
              value={String(selectedImageID)}
            >
              {images.map((image) => (
                <MenuItem
                  key={String(image._id)}
                  value={String(image._id)}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                    }}
                  >
                    <img
                      style={{ height: "40px", maxWidth: "100px", objectFit: "contain" }}
                      src={`images/${image.thumbFile || image.file}`}
                      onError={(e) => { }}
                    />
                    {image.uploadedFileName && (
                      <div
                        style={{
                          justifyContent: "center",
                          display: "flex",
                          alignItems: "center",
                          marginLeft: "15px",
                        }}
                      >
                        <Tooltip
                          key={_.get(image, "_id")}
                          id="uploadedFileName_tooltip"
                          title={image.uploadedFileName}
                          enterDelay={1000}
                          leaveDelay={200}
                          placement="bottom-start"
                        >
                          <Typography style={{ textOverflow: "ellipsis", width: "170px", overflow: "hidden" }}>
                            {image.uploadedFileName}{" "}
                          </Typography>
                        </Tooltip>
                      </div>
                    )}
                  </div>
                  {selectedImageID !== image._id && (
                    <div
                      style={{
                        float: "right",
                      }}
                    >
                      <IconButton
                        className={classes.iconButton}
                        onClick={(e) => {
                          e.stopPropagation();
                          if (props.userPermissions["deleteContent"] === false) {
                            props.createSnackbar(
                              "You do not have permission to delete, contact your administrator.",
                              "warning",
                              false
                            );
                            return;
                          }
                          setImageToDelete(image);
                          setIsDeleteImageDialogOpen(true);
                        }}
                      >
                        <Remove />
                      </IconButton>
                    </div>
                  )}
                </MenuItem>
              ))}
            </Select>
            {isUploading ? (
              <CircularProgress size={24} color="secondary" style={{ margin: "0 4px" }} />
            ) : (
              <IconButton
                id={`${props.id}.uploadButton`}
                className={classes.iconButton}
                onClick={(e) => {
                  if (props.userPermissions["manageAssets"] === false) {
                    props.createSnackbar(
                      "You are not authorized to insert, contact your administrator.",
                      "warning",
                      false
                    );
                    return;
                  }
                  if (props.userPermissions["editContent"] === false) {
                    props.createSnackbar(
                      "You are not authorized to update, contact your administrator.",
                      "warning",
                      false
                    );
                    return;
                  }
                  document.getElementById(inputID).click();
                }}
              >
                <AddIcon />
              </IconButton>
            )}
            {/* <canvas id="canvasID" ref={canvasRef} style={{ display: "none" }} /> */}

            <DialogImageDelete
              isOpen={isDeleteImageDialogOpen}
              setIsOpen={(value) => setIsDeleteImageDialogOpen(value)}
              createSnackbar={props.createSnackbar}
              imageToDelete={imageToDelete}
              selectedImageID={selectedImageID}
              images={images}
              setImages={setImages}
              selectImage={selectImage}
              deleteImageFromMedia={props.deleteImageFromMedia}
            />
          </div>
        </>
      )}
    </div>
  );
}
